

































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';

@Component({
  components: {EditDialog},
})
export default class DtcpAccelerometerModuleFreqAndBandEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  // Нельзя сохранять пустую строку
  saveWithCheck() {
    if (!this.data.central_frequency && !this.data.bandwidth) {
      this.setupErrors({'common': ['Один из параметров должен быть заполнен']});
      return;
    }
    this.save();
  }
}
